import { getGetAdminInvoiceReportSummaryQueryKey } from 'ap-openapi';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateAdminInvoiceReportDrawer = (
  selectedId: string | null
) => {
  const queryClient = useQueryClient();

  const invalidateDrawerIfOpen = useCallback(
    (reportId: string) => {
      if (selectedId === reportId) {
        queryClient.invalidateQueries({
          queryKey: getGetAdminInvoiceReportSummaryQueryKey(reportId),
        });
      }
    },
    [selectedId, queryClient]
  );

  return { invalidateDrawerIfOpen };
};
